module.exports = __webpack_public_path__ + "img/banner1.ca67a2bc.png";